import { formatDate } from "./dateUtils";

export const calcStreak = (habit) => {
  const today = new Date();
  const todayDateStr = formatDate(today);
  let streak = 0;
  const d = new Date(today);

  // If today isn't marked done yet, start counting from yesterday
  if (habit.entries[todayDateStr] !== "done") {
    d.setDate(d.getDate() - 1);
  }

  while (true) {
    const dateStr = formatDate(d);
    if (habit.entries[dateStr] === "done") {
      streak++;
      d.setDate(d.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
};

export const calcBestStreak = (habit) => {
  const doneDates = Object.entries(habit.entries)
    .filter(([, v]) => v === "done")
    .map(([k]) => k)
    .sort();

  if (doneDates.length === 0) return 0;

  let best = 1, current = 1;
  for (let i = 1; i < doneDates.length; i++) {
    const prev = new Date(doneDates[i - 1] + "T00:00:00");
    const curr = new Date(doneDates[i] + "T00:00:00");
    const diff = (curr - prev) / (1000 * 60 * 60 * 24);
    if (diff === 1) {
      current++;
      if (current > best) best = current;
    } else {
      current = 1;
    }
  }
  return best;
};
